import * as React from 'react';
import { getAuctioneerDirectoryUrl, getAuctionResultsUrl } from '@/utils/urls';
import { FormattedMessage } from 'react-intl';
import { getBaseUrl } from '../../../redux/modules/config';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const LACrown = () => {
    const baseUrl = useSelector(getBaseUrl, isEqual);

    return (
        <StyledCrown>
            <StyledCrownInner>
                <Link route secondary to={getAuctioneerDirectoryUrl()}>
                    <FormattedMessage id="directory" />
                </Link>
                <Link route secondary to={getAuctionResultsUrl()}>
                    <FormattedMessage id="price_results" />
                </Link>
                <Link secondary target="_blank" to={`${baseUrl}/news/`}>
                    <FormattedMessage id="news" />
                </Link>
                <Link rel="noopener" secondary target="_blank" to="https://help.liveauctioneers.com/">
                    <FormattedMessage id="help" />
                </Link>
                <Link route secondary to="/consignments">
                    <FormattedMessage id="consign" />
                </Link>
            </StyledCrownInner>
        </StyledCrown>
    );
};

export default React.memo(LACrown);

const StyledCrown = styled.div`
    background-color: ${({ theme }) => theme.colors.beige100};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
    font-size: 12px;
    display: flex;
    padding: 7px 20px;

    @media (max-width: 767px) {
        font-size: 10px;
    }
`;

const StyledCrownInner = styled.div`
    flex: 1 1 auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.pageWidth}) {
        margin: 0 auto;
        max-width: ${({ theme }) => theme.breakpoints.pageWidth};
        padding: 0 20px;
    }

    & > * {
        padding-right: 2em;

        @media (max-width: 767px) {
            padding-right: 1em;
        }
    }

    & > a {
        &:hover {
            color: ${({ theme }) => theme.colors.black};
            text-decoration: underline;
        }
    }

    & > span {
        color: ${({ theme }) => theme.colors.grey300};
    }
`;
